import { PromptChipItem, PromptChips } from '../prompt-chips/prompt-chips';

interface BizySidePanelSuggestedPromptsProps {
	fontSize?: 'sm' | 'md';
	items: PromptChipItem[];
	onSelectPrompt: (prompt: string) => void;
	layout?: 'vertical' | 'horizontal';
}

export function BizySidePanelSuggestedPrompts({ fontSize, items, onSelectPrompt, layout = 'vertical' }: BizySidePanelSuggestedPromptsProps) {
	return <PromptChips fontSize={fontSize} items={items} onSelectPrompt={(prompt) => onSelectPrompt(prompt)} layout={layout} />;
}
